export const orderFieldMailingLabelsData = (selectedAddress) => {

  const filterData = [
  {
    collectionName: "Account",
    fieldName: "account.mailLabelName",
    displayName: "Mail Label Name",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.location.formattedAddress",
    displayName: selectedAddress === "active-address" ? "Active Address" : "Billing Address",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.addressLine2",
    displayName: selectedAddress === "active-address" ? "Active Address Line 2" : "Billing Address Line 2",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.city",
    displayName: selectedAddress === "active-address" ? "Active City" : "Billing City",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.state",
    displayName: selectedAddress === "active-address" ? "Active State" : "Billing State",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.zip_code",
    displayName: selectedAddress === "active-address" ? "Active Zip code" : "Billing Zip code",
  },
  {
    collectionName: "Account",
    fieldName: "account.addresses.country",
    displayName: selectedAddress === "active-address" ? "Active Country" : "Billing Country",
  },

]
  return filterData;
}